import type { Types } from '@amplitude/analytics-browser';

// Avoid analytics-core's MemoryStorage: next-web does not declare it and the hoisted package is a different major from the version analytics-browser uses internally.
export const createAmplitudeMemoryStorage = <T>(): Types.Storage<T> => {
  const store = new Map<string, T>();

  return {
    isEnabled: async () => true,
    get: async (key) => store.get(key),
    getRaw: async (key) => {
      const value = store.get(key);
      return value === undefined ? undefined : JSON.stringify(value);
    },
    set: async (key, value) => {
      store.set(key, value);
    },
    remove: async (key) => {
      store.delete(key);
    },
    reset: async () => {
      store.clear();
    },
  };
};
